export default {"src":"/_next/static/media/facebook.ac8c50d2.svg","height":601,"width":600,"blurWidth":0,"blurHeight":0};